define ['./landing.css'], () ->
  ($scope, $timeout, $state, $location, $anchorScroll, content, $uibModal) ->
    $scope.toggle_1 = true
    $scope.myInterval = 6000
    $scope.activeSlide = 0;
    $scope.slides = [
      {
        name: 'Candice Meyers',
        title: 'Landlord',
        content: 'These rental applications have made renting out my townhouse so much easier. It has taken the hassle out of applications for me the landlord and for the tenant. Thank you for making such a great product.'
      },
      {
        name: 'Ben',
        title: 'Managing Broker',
        content: "Deals take 2 hours instead of 3 to 4 days. I'm able to get information to clients quicker, they're able to decide quicker, and it gets deals progressing quicker."
      },
      {
        name: 'Helen Gray',
        title: 'Landlord',
        content: "When we need to screen tenants, we need a service that's reliable, convenient and safe for all parties. Rent Application is all of that."
      }
    ]
    
    if $location.search().title
      $scope.landing_content = $location.search()
    else
      $scope.landing_content = 
        title: "Screen Your Tenants Fast" 
        subtitle: "With Instant Online Applications and Background Checks"
        cta: "Start Screening Today"
        step_title:"Tenant screening in simple steps"

    if content
      $scope.landing_content = _.merge($scope.landing_content, content)

    $scope.show_credit_report = () -> 
      $scope.toggle_1 = true     
      $scope.toggle_2 = false
      $scope.toggle_3 = false
    
    $scope.show_criminal_report = () -> 
      $scope.toggle_1 = false     
      $scope.toggle_2 = true
      $scope.toggle_3 = false
    
    $scope.show_eviction_report = () -> 
      $scope.toggle_1 = false     
      $scope.toggle_2 = false
      $scope.toggle_3 = true
      
    $scope.open_modal = () ->
      $uibModal.open
        scope: $scope
        template: require("./report-modal.jade")
        windowClass: 'report-modal-popup'
        



// WEBPACK FOOTER //
// ./components/home/landing/landing.coffee